module.exports = __webpack_public_path__ + "img/kakaopay.859cc472.png";